export default "__VITE_ASSET__Ca254Lt8__"